import React from "react";
import ReactDOM from "react-dom/client";
import i18next from "i18next";
import { Provider } from "react-redux";
import { Auth, Amplify } from "aws-amplify";
import { I18nextProvider } from "react-i18next";
import { ThemeSwitcherProvider } from "react-css-theme-switcher";
import { store } from "./app/store";

import "./index.less";
import "bootstrap/dist/css/bootstrap.min.css";

import globalES from "./translations/es/global.json";
import globalEN from "./translations/en/global.json";

import config from "./config";
import RootRouter from "./routers/RootRouter";

import { loadUserVariant, normalizeVariant, isMultiVariant } from "./config/useRouterVersionConfig";

import { DEFAULT_APP_VERSION, VARIANT_VX } from "./constants/login";

const themes = {
	dark: `${process.env.PUBLIC_URL}/dark-theme.css`,
	light: `${process.env.PUBLIC_URL}/light-theme.css`,
	blue: `${process.env.PUBLIC_URL}/blue-theme.css`,
};

i18next.init({
	interpolation: { escapeValue: false },
	lng: "en",
	resources: {
		es: { global: globalES },
		en: { global: globalEN },
	},
});

Amplify.configure({
	Auth: {
		mandatorySignIn: true,
		region: config.cognito.REGION,
		userPoolId: config.cognito.USER_POOL_ID,
		identityPoolId: config.cognito.IDENTITY_POOL_ID,
		userPoolWebClientId: config.cognito.APP_CLIENT_ID,
	},
	Storage: {
		region: config.s3.REGION,
		bucket: config.s3.BUCKET,
		identityPoolId: config.cognito.IDENTITY_POOL_ID,
	},
	API: {
		endpoints: [{ name: "notes", endpoint: config.apiGateway.URL, region: config.apiGateway.REGION }],
	},
});

Auth.configure({
	Auth: {
		mandatorySignIn: true,
		region: config.cognito.REGION,
		userPoolId: config.cognito.USER_POOL_ID,
		identityPoolId: config.cognito.IDENTITY_POOL_ID,
		userPoolWebClientId: config.cognito.APP_CLIENT_ID,
		oauth: {
			domain: config.cognito.OAUTH_DOMAIN,
			scope: ["email", "openid", "profile", "aws.cognito.signin.user.admin"],
			redirectSignIn: config.cognito.REDIRECT_SIGN_IN,
			redirectSignOut: config.cognito.REDIRECT_SIGN_OUT,
			responseType: "code",
		},
	},
	Storage: {
		region: config.s3.REGION,
		bucket: config.s3.BUCKET,
		identityPoolId: config.cognito.IDENTITY_POOL_ID,
	},
	API: {
		endpoints: [{ name: "notes", endpoint: config.apiGateway.URL, region: config.apiGateway.REGION }],
	},
});

const rootElement = document.getElementById("root");
if (!rootElement) {
	throw new Error("The element #root wasn't found");
}

const root = ReactDOM.createRoot(rootElement);

async function bootstrap() {
	const variantRaw = await loadUserVariant();
	const variant = isMultiVariant(variantRaw)
		? VARIANT_VX
		: (normalizeVariant(variantRaw) || DEFAULT_APP_VERSION).replace(/^\/+/, "");

	localStorage.setItem("userValidVersion", variant);

	root.render(
		<Provider store={store}>
			<I18nextProvider i18n={i18next}>
				<ThemeSwitcherProvider themeMap={themes} defaultTheme='light'>
					<RootRouter variant={variant} />
				</ThemeSwitcherProvider>
			</I18nextProvider>
		</Provider>
	);
}

bootstrap().catch(() => {
	const fallback = DEFAULT_APP_VERSION;
	localStorage.setItem("userValidVersion", fallback);

	root.render(
		<Provider store={store}>
			<I18nextProvider i18n={i18next}>
				<ThemeSwitcherProvider themeMap={themes} defaultTheme='light'>
					<RootRouter variant={fallback} />
				</ThemeSwitcherProvider>
			</I18nextProvider>
		</Provider>
	);
});

// register()
// swDev()
